import React from "react";
import { Dropdown } from "react-bootstrap";
import { Link } from "react-router-dom";
import { Trans } from "react-i18next";
import { firebaseServices } from "../services/firebase";

import { storageServices } from "../services/storage";

import { useState, useEffect } from 'react';


export function Navbar(props) {

  const [state, setState] = useState({name:'',picture:'',providerId:''});

  useEffect(() => {

    async function loadUser (){
    let currentUser = await storageServices.getCurrentUser() 
    try {
     
      if (currentUser?.providerId=='facebook.com')
      {
        setState({name:currentUser?.facebook?.userProfile?.name,
          picture:currentUser?.facebook?.userProfile?.picture,
          providerId:currentUser?.providerId})
      }
    }
    catch (e) {
        console.log("Error in header:",e)
    }
  }
    loadUser()
  
  }, [])

 

  function toggleOffcanvas() {
    document.querySelector(".sidebar-offcanvas").classList.toggle("active");
  }
  
  async function logOut() {
    await firebaseServices.signOut();
  }


  // function toggleRightSidebar() {
  //   document.querySelector(".right-sidebar").classList.toggle("open");
  // }

 
  // function addDefaultSrc(ev) {
  //   ev.target.src =
  //     "https://img.icons8.com/officel/80/000000/user-male-circle.png";
  // }

  return (
    <nav className="navbar default-layout-navbar col-lg-12 col-12 p-0 fixed-top d-flex flex-row">
      <div className="text-center navbar-brand-wrapper d-flex align-items-center justify-content-center">
        <Link className="navbar-brand brand-logo" to="/">
          <img src="/images/logo.png" alt="logo" />
        </Link>
        <Link className="navbar-brand brand-logo-mini" to="/">
          <img src="/images/logo-mini.png" alt="logo" />
        </Link>
      </div>
      <div className="navbar-menu-wrapper d-flex align-items-stretch">
        <button
          className="navbar-toggler navbar-toggler align-self-center"
          type="button"
          onClick={() => document.body.classList.toggle("sidebar-icon-only")}
        >
          <span className="mdi mdi-menu"></span>
        </button>

        <ul className="navbar-nav navbar-nav-right">
          <li className="nav-item">
            <Dropdown alignRight>
              <Dropdown.Toggle className="nav-link count-indicator">
                <i className="mdi mdi-bell-outline"></i>
                <span className="count-symbol bg-danger"></span>
              </Dropdown.Toggle>
              <Dropdown.Menu className="dropdown-menu navbar-dropdown preview-list">
                <h6 className="p-3 mb-0">
                  <Trans>Notifications</Trans>
                </h6>
                <div className="dropdown-divider"></div>
                <div className="dropdown-divider"></div>
                <h6 className="p-3 mb-0 text-center cursor-pointer">
                  <Trans>No notifications</Trans>
                </h6>
              </Dropdown.Menu>
            </Dropdown>
          </li>
          <li className="nav-item nav-profile">
            <Dropdown alignRight>
              <Dropdown.Toggle className="nav-link">
                <div className="nav-profile-img">
                  {/* <img src={require("../assets/images/faces/face1.jpg")} alt="user"/> */}
                  <img
                    src={state.picture}
                    onError="this.src='../assets/images/faces/face1.jpg'"
                  />

                  <span className="availability-status online"></span>
                </div>
                <div className="nav-profile-text">
                  <p className="mb-1 ">{state.name}</p>
                </div>
              </Dropdown.Toggle>

              <Dropdown.Menu className="navbar-dropdown">
                <Dropdown.Item onClick={() => logOut()}>
                  <i className="mdi mdi-logout mr-2 text-primary"></i>
                  <Trans>Signout</Trans>
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </li>
        </ul>
        <button
          className="navbar-toggler navbar-toggler-right d-lg-none align-self-center"
          type="button"
          onClick={() => toggleOffcanvas()}
        >
          <span className="mdi mdi-menu"></span>
        </button>
      </div>
    </nav>
  );
}

export default Navbar;
